import { useEffect } from 'react'
import './ShipmentPickerModal.css'

function formatPrice(price) {
  const n = typeof price === 'string' ? parseFloat(price) : Number(price)
  if (!Number.isFinite(n)) return '—'
  return Number.isInteger(n) ? String(n) : n.toFixed(2)
}

function ShipmentPickerModal({ isOpen, shipments, selectedId, onSelect, onClose }) {
  useEffect(() => {
    if (!isOpen) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="shipment-picker-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Выбор доставки"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.()
      }}
    >
      <div className="shipment-picker-sheet">
        <div className="shipment-picker-header">
          <div className="shipment-picker-title">Зона доставки</div>
          <button
            type="button"
            className="shipment-picker-close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>

        <div className="shipment-picker-body">
          {shipments.length === 0 ? (
            <div className="shipment-picker-empty">Нет доступных зон доставки</div>
          ) : (
            <ul className="shipment-picker-list">
              {shipments.map((shipment) => {
                const id = shipment?.id ?? shipment?._id
                const isSelected = String(id) === String(selectedId)
                const locationName = shipment?.locationName || `Доставка #${id}`
                const priceLabel = formatPrice(shipment?.price)

                return (
                  <li key={id}>
                    <button
                      type="button"
                      className={`shipment-picker-item${isSelected ? ' shipment-picker-item--selected' : ''}`}
                      onClick={() => {
                        onSelect?.(shipment)
                        onClose?.()
                      }}
                      aria-pressed={isSelected}
                    >
                      <span className="shipment-picker-itemMain">
                        <span className="shipment-picker-itemName">{locationName}</span>
                        <span className="shipment-picker-itemPrice">{priceLabel} сом</span>
                      </span>
                      <span
                        className={`shipment-picker-radio${isSelected ? ' shipment-picker-radio--checked' : ''}`}
                        aria-hidden
                      />
                    </button>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

export default ShipmentPickerModal
